export default __webpack_public_path__ + "static/FW-307f0a310e32655c52be68eedec79dce.pdf";